import React from 'react';
import Subtopics from './Subtopics';
import { Container } from "react-bootstrap";
import {
    Switch,
    Route,
    Link,
    useRouteMatch
  } from "react-router-dom";

function Basics(props) {
    let { path, url } = useRouteMatch();
    return (
        <div>
            <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', maxWidth: "100vw"}}>
                {/* <SectionTitle title={props.topicId}/> */}
            <div style={{display: 'flex', flexDirection: 'row'}}> 
            <div style={{marginTop: '10px', marginRight: '0px', marginLeft: '5px',border: '3px', padding:'40px', paddingRight: '50px', borderStyle:'solid', borderColor:'grey', paddingLeft: '20px', whiteSpace:'nowrap'}}>
                <h2>Computer Basics</h2>
                {/* <li>
                    <Link to={`${url}/numbersystems`}>Number Systems</Link>
                </li> */}
                <li>
                    <Link to={`${url}/logic`}>Logic Operations</Link>
                </li>
                <li>
                    <Link to={`${url}/variables`}>Variables</Link>
                </li>
                <li>
                    <Link to={`${url}/loops`}>Loops</Link>
                </li>
                <li>
                    <Link to={`${url}/conditionals`}>Conditionals</Link>
                </li>
                <li>
                    <Link to={`${url}/functions`}>Functions</Link>
                </li>
                {/* <li>
                    <Link to={`${url}/networking`}>Computer Networking</Link>
                </li>
                <li>
                    <Link to={`${url}/internet`}>The Internet</Link>
                </li>
                <li>
                    <Link to={`${url}/security`}>Data Security</Link>
                </li>             */}
                </div>
                
            <Container>
                <Switch>
                    <Route exact path={path}>
                    <h3>Please select a sub-topic.</h3>
                    </Route>
                    <Route path={`${path}/:topicId`}>
                        <Subtopics />
                    </Route>
                </Switch>
            </Container>
         
                    </div>
            </div>
        </div>
    );
};

export default Basics; 